import { render } from "./QualificationApproval.vue?vue&type=template&id=2269ab00&ts=true"
import script from "./QualificationApproval.vue?vue&type=script&lang=ts"
export * from "./QualificationApproval.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "F:\\Waddecar Media\\Development\\Forms\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__